import * as React from "react";

import { Well } from "react-bootstrap";

type Props = {
    children?: React.ReactNode;
    className?: string;
    caption: React.ReactNode;
    initialOpen?: boolean;
    trackToggle: (newState: boolean) => void;
};

class CollapseFilterWrapper extends React.Component<
    Props,
    {
        open: boolean;
    }
> {
    constructor(props: Props) {
        super(props);
        this.state = { open: props.initialOpen === undefined || props.initialOpen };
    }

    toggleFilterPanelView = (event: React.SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        const newState = !this.state.open;
        this.setState({ open: newState });
        this.props.trackToggle(newState);
    };

    render() {
        const visibilityClass = this.state.open ? "icon-lg icon-chevron-up" : "icon-lg icon-chevron-down";
        const className =
            "ex-collapsible-filter btex-collapsible " +
            (this.state.open ? "open" : "closed") +
            " " +
            (this.props.className || "");

        const contentClass = "mfcss_collapsible_content";
        return (
            <Well className={className}>
                <a
                    href="#"
                    className="test-category-tree-collapsible mfcss_collapsible_headline"
                    onClick={this.toggleFilterPanelView}>
                    <h3>
                        {this.props.caption}
                        <span className="pull-right">
                            <span className="ex-toggle-filter-visibility">
                                <span className={visibilityClass} />
                            </span>
                        </span>
                    </h3>
                </a>
                <div className={contentClass}>{this.props.children}</div>
            </Well>
        );
    }
}

export default CollapseFilterWrapper;
